<template>
    <div>
        <v-card>
            <v-card-title>
                {{ $tc('Export', 3) }}
            </v-card-title>

            <v-container>

                <FromToDateFilter/>

                <v-row>

                    <v-col>
                        <v-select
                                class="ml-3 mr-3"
                                :items="fileTypes"
                                :label="$tc('FileType')"
                                :loading="fileTypeSelectIsLoading"
                                v-model="selectedFileType"
                                outlined
                                :disabled="fileTypeSelectIsLoading"
                        ></v-select>
                    </v-col>

                    <v-col>
                        <v-btn :href="downloadLink">
                            <v-icon left>
                                get_app
                            </v-icon>
                            {{ $tc('Download') }}
                        </v-btn>
                    </v-col>

                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import {mapGetters, mapState} from "vuex";
    import FromToDateFilter from "@/components/FromToDateFilter";

    export default {
        name: "Export",
        components: {FromToDateFilter},
        data: () => ({
            fileTypes: [],
            selectedFileType: '',
            fileTypeSelectIsLoading: true,
        }),
        computed: {
            ...mapGetters('common', [
                'serverURL',
            ]),
            ...mapState('common', [
                'selectedFromDate',
                'selectedToDate',
            ]),
            downloadLink: function () {
                return this.serverURL + '/export_area_payments/?'
                    + 'file_type=' + this.selectedFileType
                    + '&from_date=' + this.selectedFromDate
                    + '&to_date=' + this.selectedToDate
                    ;
            }
        },
        mounted() {
            axios
                .get(this.serverURL + '/get_exportable_file_types/')
                .then(response => {
                    this.fileTypes = response.data.file_types;
                    if (this.fileTypes.length > 0)
                    {
                        this.selectedFileType = this.fileTypes[0];
                    }
                    this.fileTypeSelectIsLoading = false;
                })
        },
    }
</script>